import { PLAYBACK_STATE } from 'js/src/components/common/video-preview/VideoPreview';

export function nextPlaybackStateOnSeek(
    currentState: PLAYBACK_STATE,
    seekTimeMs: number,
    durationMs: number,
): PLAYBACK_STATE {
    if (currentState === PLAYBACK_STATE.STOPPED && seekTimeMs < durationMs) {
        return PLAYBACK_STATE.PAUSED;
    }
    return currentState;
}
